<template>
    <div class="c-client-size-input">
        <div class="slider--container">
            <div class="slider--icon small"></div>
            <div class="slider">
                <input type="range" v-model.number="getSize" :min="min" :max="max" class="slider"/>
            </div>
            <div class="slider--icon big"></div>
        </div>

        <div class="slider--display">
            <div class="slider--label">
                {{getSize}} cm
            </div>
            <button class="slider--btn" @click.prevent="updateSize(-1)" :disabled="getSize == min">-</button>
            <button class="slider--btn" @click.prevent="updateSize(1)" :disabled="getSize == max">+</button>
        </div>
    </div>
</template>

<script>
import {clamp} from "@/utils/utils.js";

export default {
    name : "ClientSizeInput",
    props: {
        size : {type : Number, default : 100}
    },
    data() {
        return {
            min: 100,
            max : 220
        };
    },

    computed: {
        getSize: {
            get: function() {
                return this.size;
            },
            set: function(value) {
                this.$emit("update:size", parseInt(value));
            }
        }
    },

    methods: {
        updateSize(delta) {
            this.getSize = clamp(this.getSize + delta, this.min, this.max);
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-client-size-input {
        width : 65%;
    }

    .slider {
        width : 80%;
        height : 100%;
        position: relative;
        background: #D7DBE0;
        border-radius: 4rem;

        input[type=range] {
           position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin : 0;
        }

        &--container {
            width : 100%;
            height : 4vh;
            position: relative;
            display:flex;
            margin-top: 5%;
            @include slideIntroAnimation(basicSlideIntro, 450ms, 350ms);

        }

        &--icon {
            background-image: url('/img/appointment_edit/icon-size.svg');
            background-repeat: no-repeat;
            background-position: center bottom;
            width : 8%;
            height: 150%;
            margin-top: -1.4%;

            &.small {
                background-size : 25%;
            }
        }

        &--display {
            display: flex;
            align-content: center;
            justify-content: center;
            margin-top: 10%;
            align-items: center;
            @include slideIntroAnimation(basicSlideIntro, 450ms, 750ms);

        }

        &--label {
            background : white;
            font-size: 2rem;
            padding : 1rem;
            border-radius: 3rem;
            width: 6em;
        }

        &--btn {
            @extend .reset-btn;
            background: linear-gradient(270deg, $color-blue 0%, darken($color-blue, 20%) 100%);
            margin: 0 .5rem;
            width: 3rem;
            height: 3rem;
            display: block;
            font-size: 3em;
            color:white;
            border-radius: 1.5rem;
            line-height: 1em;
            padding : 0;

            &:disabled {
                opacity: .5;
            }
        }
    }
</style>